import type { LogisticsOrderStatus } from '@/modules/logistics/types';
import type { MaintenanceStatus } from '@/modules/maintenance/types/maintenance';
import type { ReservationStatus } from '@/modules/reservations/types';

export const CALENDAR_RESERVATION_STATUS_CLASS: Record<
  ReservationStatus,
  string
> = {
  draft: 'calendar-event--draft',
  confirmed: 'calendar-event--confirmed',
  in_progress: 'calendar-event--in-progress',
  completed: 'calendar-event--completed',
  cancelled: 'calendar-event--cancelled',
};

export const CALENDAR_LOGISTICS_STATUS_CLASS: Record<
  LogisticsOrderStatus,
  string
> = {
  pending: 'calendar-event--log-pending',
  scheduled: 'calendar-event--log-scheduled',
  in_transit: 'calendar-event--log-in-transit',
  delivered: 'calendar-event--log-delivered',
  returned: 'calendar-event--log-returned',
  cancelled: 'calendar-event--log-cancelled',
};

export const CALENDAR_MAINTENANCE_STATUS_CLASS: Record<
  MaintenanceStatus,
  string
> = {
  scheduled: 'calendar-event--mnt-scheduled',
  in_progress: 'calendar-event--mnt-in-progress',
  completed: 'calendar-event--mnt-completed',
  cancelled: 'calendar-event--mnt-cancelled',
};

export function calendarEventClassName(event: {
  source: 'reservation' | 'logistics' | 'maintenance';
  reservationStatus?: ReservationStatus;
  logisticsStatus?: LogisticsOrderStatus;
  maintenanceStatus?: MaintenanceStatus;
}): string {
  const base = 'calendar-event';
  if (event.source === 'maintenance') {
    const status = event.maintenanceStatus ?? 'scheduled';
    return `${base} calendar-event--maintenance ${CALENDAR_MAINTENANCE_STATUS_CLASS[status]}`;
  }
  if (event.source === 'logistics') {
    const status = event.logisticsStatus ?? 'pending';
    return `${base} calendar-event--logistics ${CALENDAR_LOGISTICS_STATUS_CLASS[status]}`;
  }
  const status = event.reservationStatus ?? 'draft';
  return `${base} ${CALENDAR_RESERVATION_STATUS_CLASS[status]}`;
}
